/**
 * Phone list column under sticky Displaying N / filter chrome.
 * Horizontal inset only — no top pad. Home flushTop removes the 32px band above
 * this feed; first MeetingGroup flush keeps the first card at the feed top.
 */
const phoneFeedCss = "p1ok7mbw";
export const MeetingsPhoneFeed = ({
  children
}) => <div className={phoneFeedCss} data-testid="meetings-phone-feed">
    {children}
  </div>;

require("./meetings_phone_feed.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./meetings_phone_feed.js");